import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionWrapper } from '../SectionWrapper';
import { FormInput } from '../merchants/FormInput';
import { UrlList } from '../merchants/sites/UrlList';
import { FORM_FIELDS, FORM_FIELDS_NAMES } from '../../constants/new-application/new-application-form';
import { BUSINESS_MODEL_INPUTS } from '../../constants/new-application/business-modal';
import { useMerchants } from '../../store/merchnts/merchants-context';


interface Props {
  formik: any;
  formEditStatus?: boolean;
  isRequired: boolean;
  urls: string[];
}

export const BusinessModel: FC<Props> = (props) => {
  const { t } = useTranslation();
  const { formik, formEditStatus = true, isRequired, urls } = props;
  const { merchantState } = useMerchants();
    const { merchantsLists: lists } = merchantState;

  const [tags, setTags] = useState<string[]>([]);

  const INPUTS = BUSINESS_MODEL_INPUTS({ t, lists, isRequired });

  useEffect(() => {
    if (urls.length > 0) {
      setTags(urls);
    }
  }, [urls]);

  return (
    <SectionWrapper
      title={t('NEW_APPLICATION.BUSINESS_MODEL')}
      pageLoading={false}
      isCardBody
      sectionAdditionalClass="mb-10"
    >
      <div className="row">
        {
          INPUTS.map(item => (
            <FormInput
              {...item}
              formik={formik}
              key={item.key}
              isEditMode={formEditStatus}
            />
          ))
        }
      </div>

      <UrlList
        formik={formik}
        urls={tags}
        setUrls={setTags}
        isAdmin={formEditStatus}
        fieldName={FORM_FIELDS.URLS}
        title={t(FORM_FIELDS_NAMES.URLS)}
        label="url"
        isRequired={isRequired}
        isEditMode={formEditStatus}
      />

      {
        formEditStatus && (
          <>
            <div className="fs-9 text-muted">
              Choose ‘https://’ or ‘http://’ before every domain.
            </div>
            {/*<div className="fs-9 text-muted">*/}
            {/*  You can bulk input multiple URLs by simply copy-pasting your domains, separated by commas.*/}
            {/*</div>*/}
          </>
        )
      }

    </SectionWrapper>
  );
};
